export default __webpack_public_path__ + "static/media/appScreenBg.b1ee5a35.png";